import React, {useState} from 'react'
import { Formik, Form, Field, FieldArray, FastField } from "formik";
import { useNavigate } from 'react-router-dom';

export default function Assemblyitems() {
  const [ShowUserDropDown, setShowUserDropDown] = useState(false);
  const [ShowTypeDropDown, setShowTypeDropDown] = useState(false);
  const [ShowstatusDropDown, setShowstatusDropDown] = useState(false);
  const [ShowsupplierDropDown, setShowsupplierDropDown] = useState(false);
  const [ShowcompanyDropDown, setShowcompanyDropDown] = useState(false);
  const navigate = useNavigate();

  const [Users, setUsers] = useState([
    {
      full_name: "",
    },
  ]);
  const initialValues = {
    name: "",
    users: "",
    street_name: "",
    door_number: "",
    country: "",
    city: "",
    phone_number: "",
    website: "",
    contacts: [],
  };
  const onSubmit = (values, onSubmitProps) => {};
  const RemoveTemplateHandler = (remove, index) => {
    remove(index);
  };
  const AddTemplateHandler = (push) => {
    push({
      name: "",
      job_role: "",
      phone_number: "",
      email: "",
    });
  };
  return (
    <div>
    <div>
    <h2 className="font-Montserrat text-xl font-bold text-black">
      Scan/Print barcodes
    </h2>
    <div className="border-b-2 border-blue-200 w-20"></div>
  </div>
  <div className="flex flex-col justify-items-center ml-8 mt-12 bg-white pl-8 py-8">
    <div className="flex mb-8">
      <h2 className="font-Montserrat text-lg font-medium text-black mr-2">
        Print Barcode for Assembly
      </h2>
     
      <svg width="25" height="32" viewBox="0 0 106 152" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_997_6425)">
          <path d="M82.4635 74.4276V102.04L58.9749 115.281L29.5117 98.6995V70.967L59.0231 87.7892L82.4635 74.4276ZM55.9635 88.8466L34.2817 76.3021V95.8157L55.9635 108.144V88.8466ZM77.6454 79.8347L72.8272 82.4301V88.8466L65.5999 92.9079V86.131L60.7817 88.7264V108.817L77.6454 99.2042V79.8347Z" fill="#AD8762"/>
          <path d="M82.2676 74.4223L105.997 61.1328V88.8413L82.4603 102.083C82.4603 92.8786 82.4603 83.7466 82.2676 74.5425V74.4223ZM101.179 66.3236L96.3608 68.895V75.5998L89.1335 79.6612V72.7881L84.3153 75.3836V95.474L101.179 85.8613V66.3236Z" fill="#AD8762"/>
          <path d="M29.5355 71.0668V98.7032L0 81.9291V54.2927L29.5355 71.0668ZM26.5 71.8839L4.81818 59.3634V79.0453L26.5 91.2534V71.8839Z" fill="#AD8762"/>
          <path d="M82.4635 46.7385V74.4229L58.9749 87.7845L29.5117 71.0345V43.302L53.0004 30.0605L82.4635 46.7385ZM49.1217 37.7507L70.8035 50.199L74.899 47.9881L53.0004 35.5638L49.1217 37.7507ZM55.9635 61.0133L34.2817 48.4928V68.1747L55.9635 80.4789V61.0133ZM63.1908 54.2604L42.0149 41.7399L37.1967 44.5276L58.5413 56.8798L63.1908 54.2604ZM77.6454 52.0014L72.8272 54.5968V61.3017L65.5999 65.339V58.49L60.7817 61.0854V81.1758L77.6454 71.5632V52.0014Z" fill="#AD8762"/>
          <path d="M106 33.5704V61.1347L82.4632 74.4242C82.4632 65.2201 82.4632 56.1121 82.2705 46.8839L53 30.0618L76.5368 16.7483L106 33.5704ZM72.61 24.4144L94.2918 36.8628L98.3873 34.6519L76.4405 22.2275L72.61 24.4144ZM86.7273 40.9241L65.4791 28.4036L60.6609 31.1913L81.9091 43.5436L86.7273 40.9241ZM101.182 38.6651L96.3636 41.2605V47.9894L89.1364 52.0507V45.1537L84.3182 47.725V67.8395L101.182 58.2269V38.6651Z" fill="#AD8762"/>
          <path d="M53 30.2352L29.5355 43.4285V71.0409L0 54.2908V26.6304L23.5368 13.365L53 30.2352ZM19.5859 20.983L41.2677 33.4314L45.3632 31.2205L23.4164 18.7961L19.5859 20.983ZM26.5 44.2456L4.81818 31.7011V51.383L26.5 63.7112V44.2456ZM33.7273 37.4927L12.4791 24.9482L7.54045 27.7599L28.9091 40.1122L33.7273 37.4927Z" fill="#AD8762"/>
          <path d="M52.7392 30.2301C43.1028 24.6308 33.2978 18.9593 23.541 13.408L47.0056 -0.0737305L76.541 16.7484L52.7392 30.1821V30.2301ZM43.1028 7.59236L64.7846 20.0167L68.8801 17.8298L46.9574 5.45354L43.1028 7.59236ZM57.2442 24.1021L35.996 11.5576L31.1778 14.3693L52.5224 26.6975L57.2442 24.1021Z" fill="#AD8762"/>
          <path d="M82.4635 102.04V129.7L58.9749 143.038L29.5117 126.36V98.6035L59.0231 115.426L82.4635 102.04ZM55.9635 116.339L34.2817 103.794V123.476L55.9635 135.804V116.339ZM77.6454 107.327L72.8272 109.898V116.603L65.5999 120.665V113.791L60.7817 116.387V136.477L77.6454 126.865V107.327Z" fill="#AD8762"/>
          <path d="M82.2676 102.157L105.997 88.8433V116.48L82.4603 129.697C82.4603 120.493 82.4603 111.361 82.2676 102.157ZM101.179 93.962L96.3608 96.5574V103.262L89.1335 107.324V100.451L84.3153 103.046V123.136L101.179 113.524V93.962Z" fill="#AD8762"/>
          <path d="M29.5355 98.7271V126.363L0 109.589V81.929L29.5355 98.7271ZM26.5 99.5441L4.81818 86.9996V106.682L26.5 119.01V99.5441Z" fill="#AD8762"/>
          <path d="M82.4635 129.696V138.66L58.9749 152.021L29.5117 135.344V126.356L59.0231 143.034L82.4635 129.696ZM55.9635 141.327L34.2817 129.047V132.46L55.9635 144.764V141.327ZM77.6454 132.436L60.7817 142.048L58.9749 143.082L60.7817 142.048V145.509L77.6454 135.896V132.436Z" fill="#AD8762"/>
          <path d="M84.314 128.67L105.996 116.438V125.425L82.459 138.667V129.727L84.314 128.67ZM101.178 119.177L84.314 128.67V132.106L101.178 122.493V119.177Z" fill="#AD8762"/>
          <path d="M29.5114 126.385V135.348L0 118.574V109.586L29.5114 126.385ZM26.5 124.63L4.81818 112.302V115.666L26.5 127.995V124.63Z" fill="#AD8762"/>
          </g>
          <defs>
          <clipPath id="clip0_997_6425">
          <rect width="106" height="152" fill="white"/>
          </clipPath>
          </defs>
          </svg>
    </div>
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      //   validationSchema={validationSchema}
      //   validateOnMount
    >
      <Form>
        <div className="grid space-y-8">
          <Field name="item">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  <button
                    id="dropdownButton"
                    className=" font-Montserrat border-1 border-solid border-gray
          focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3  bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                    type="button"
                    onClick={() => setShowUserDropDown(!ShowUserDropDown)}
                  >
                    Select Item/Assembly
                    <svg
                      className="w-4 h-4 ml-auto"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  {ShowUserDropDown ? (
                    <div>
                      <div
                        id="dropdown"
                        className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                      >
                        <ul
                          className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                          aria-labelledby="dropdownRightButton"
                          {...field}
                        >
                          {Users.map((users, index) => (
                            <li key={index}>
                              <a className="block px-4 py-2 hover:bg-cyan-200">
                                {users.full_name === ""
                                  ? null
                                  : users.full_name}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </>
              );
            }}
          </Field>
          <Field name="version">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  <button
                    id="dropdownButton"
                    className=" font-Montserrat border-solid border-gray
          focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                    type="button"
                    onClick={() => setShowTypeDropDown(!ShowTypeDropDown)}
                  >
                    Select Version
                    <svg
                      className="w-4 h-4 ml-auto"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  {ShowTypeDropDown ? (
                    <div>
                      <div
                        id="dropdown"
                        className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                      >
                        <ul
                          className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                          aria-labelledby="dropdownRightButton"
                          {...field}
                        >
                          <li>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type A
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type B
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type C
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </>
              );
            }}
          </Field>
          <Field name="purchasedate">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  {/* <svg
        width="15"
        height="20"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
          fill="black"
          fill-opacity="0.7"
        />
      </svg> */}

                  <input
                    {...field}
                    type="date"
                    {...(meta.touched && meta.error
                      ? {
                          className:
                            "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                        }
                      : {
                          className:
                            "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                        })}
                    placeholder="Purchase Date"
                  ></input>
                  {meta.touched && meta.error ? (
                    <label className="text-xs font-Montserrat text-red-500">
                      <span className="ml-1">{meta.error}</span>
                    </label>
                  ) : null}
                </>
              );
            }}
          </Field>
          <Field name="arrivaldate">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  {/* <svg
      width="15"
      height="20"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
        fill="black"
        fill-opacity="0.7"
      />
    </svg> */}

                  <input
                    {...field}
                    type="date"
                    {...(meta.touched && meta.error
                      ? {
                          className:
                            "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                        }
                      : {
                          className:
                            "border-1 bg-transparent rounded-md px-2 py-2.5 font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                        })}
                    placeholder="Arrival Date"
                  ></input>
                  {meta.touched && meta.error ? (
                    <label className="text-xs font-Montserrat text-red-500">
                      <span className="ml-1">{meta.error}</span>
                    </label>
                  ) : null}
                </>
              );
            }}
          </Field>
          <Field name="supplier">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  <button
                    id="dropdownButton"
                    className=" font-Montserrat border-solid border-gray
    focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                    type="button"
                    onClick={() =>
                      setShowsupplierDropDown(!ShowsupplierDropDown)
                    }
                  >
                    Select Supplier
                    <svg
                      className="w-4 h-4 ml-auto"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  {ShowsupplierDropDown ? (
                    <div>
                      <div
                        id="dropdown"
                        className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                      >
                        <ul
                          className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                          aria-labelledby="dropdownRightButton"
                          {...field}
                        >
                          <li>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type A
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type B
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type C
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </>
              );
            }}
          </Field>
          <Field name="tracking">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  {/* <svg
          width="15"
          height="20"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.5 12.5H10V10H12.5V12.5ZM8.75 6.25H6.25V8.75H8.75V6.25ZM12.5 6.25H10V8.75H12.5V6.25ZM5 10H2.5V12.5H5V10ZM8.75 10H6.25V12.5H8.75V10ZM5 6.25H2.5V8.75H5V6.25ZM15 1.25V15H0V1.25H1.875V1.875C1.875 2.56437 2.43563 3.125 3.125 3.125C3.81437 3.125 4.375 2.56437 4.375 1.875V1.25H10.625V1.875C10.625 2.56437 11.1856 3.125 11.875 3.125C12.5644 3.125 13.125 2.56437 13.125 1.875V1.25H15ZM13.75 5H1.25V13.75H13.75V5ZM12.5 0.625C12.5 0.28 12.2206 0 11.875 0C11.5294 0 11.25 0.28 11.25 0.625V1.875C11.25 2.22 11.5294 2.5 11.875 2.5C12.2206 2.5 12.5 2.22 12.5 1.875V0.625ZM3.75 1.875C3.75 2.22 3.47062 2.5 3.125 2.5C2.77938 2.5 2.5 2.22 2.5 1.875V0.625C2.5 0.28 2.77938 0 3.125 0C3.47062 0 3.75 0.28 3.75 0.625V1.875Z"
            fill="black"
            fill-opacity="0.7"
          />
        </svg> */}

                  <input
                    {...field}
                    type="number"
                    {...(meta.touched && meta.error
                      ? {
                          className:
                            "border-b-2 bg-transparent font-medium relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors font-Montserrat",
                        }
                      : {
                          className:
                            "border-b-2 bg-transparent font-medium relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors font-Montserrat",
                        })}
                    placeholder="Tracking Id"
                  ></input>
                  {meta.touched && meta.error ? (
                    <label className="text-xs font-Montserrat text-red-500">
                      <span className="ml-1">{meta.error}</span>
                    </label>
                  ) : null}
                </>
              );
            }}
          </Field>
          <Field name="company">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  <button
                    id="dropdownButton"
                    className=" font-Montserrat border-solid border-gray
  focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                    type="button"
                    onClick={() =>
                      setShowcompanyDropDown(!ShowcompanyDropDown)
                    }
                  >
                    Delivery Company
                    <svg
                      className="w-4 h-4 ml-auto"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  {ShowcompanyDropDown ? (
                    <div>
                      <div
                        id="dropdown"
                        className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                      >
                        <ul
                          className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                          aria-labelledby="dropdownRightButton"
                          {...field}
                        >
                          <li>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type A
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type B
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type C
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </>
              );
            }}
          </Field>
          <Field name="status">
            {(props) => {
              const { field, form, meta } = props;
              return (
                <>
                  <button
                    id="dropdownButton"
                    className=" font-Montserrat border-solid border-gray
focus:border-blue-100 focus:outline-none text-gray-50 font-medium mr-3 border-1 bg-transparent relative w-3/4 border-gray rounded-md text-sm px-2 py-2.5 text-center inline-flex items-center"
                    type="button"
                    onClick={() =>
                      setShowstatusDropDown(!ShowstatusDropDown)
                    }
                  >
                    Select Status
                    <svg
                      className="w-4 h-4 ml-auto"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                  {ShowstatusDropDown ? (
                    <div>
                      <div
                        id="dropdown"
                        className="z-10 -mt-6 absolute bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700"
                      >
                        <ul
                          className="py-1 text-sm text-gray-700 font-medium font-Montserrat"
                          aria-labelledby="dropdownRightButton"
                          {...field}
                        >
                          <li>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type A
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type B
                            </a>
                            <a className="block px-4 py-2 hover:bg-cyan-200">
                              Type C
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </>
              );
            }}
          </Field>
        </div>
      </Form>
    </Formik>

    <div className="mt-8">
      <div className="flex flex-col justify-items-center">
        <Formik
        //   initialValues={GroupInitialValues}
        //   onSubmit={GroupOnSubmit}
          //   validationSchema={validationSchema}
          //   validateOnMount
        >
          <Form>
            <div className="flex flex-row justify-center space-x-128 my-10">
              <button
                type="button"
                className="text-red-600 font-Montserrat font-medium text-lg"
                onClick={() => navigate("/dashboard/warehouse/printscan")}

              >
                Cancel
              </button>

              <button
                type="submit"
                className="font-Montserrat font-semibold text-white mr-5 flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow"
                style={{marginRight:"20px"}}
              >
                Print Barcode
              </button>
            </div>
          </Form>
        </Formik>
      </div>
    </div>
  </div>
    
    </div>
  )
}
